import { PlaceholderProps } from "react-select";
import classes from "../CountrySelect.module.scss";

const Placeholder = (props: PlaceholderProps<any, boolean>) => {
  let displayValue = "";
  const { 
    selectedCountries, 
    placeholderText,
    oneCountrySelected, 
    manyCountriesSelected
  } = props.selectProps;
  switch (selectedCountries.length) {
    case 0:
      displayValue = placeholderText;
      break;
    case 1:
      displayValue = oneCountrySelected;
      break;
    default:
      displayValue = manyCountriesSelected?.replace(
        "{n}",
        selectedCountries.length
      );
  }
  return (
    <div className={classes.selectPlaceholder}>{displayValue}</div>
  )
}

export default Placeholder;